namespace TabAurous.Production {
    export interface IssueMaterialItemsForm {
        TransDetailId: Serenity.StringEditor;
        TransItemId: Serenity.StringEditor;
        BagNo: Serenity.StringEditor;
        Line_No: Serenity.StringEditor;
        ProductId: Serenity.StringEditor;
        AttributeId: Serenity.StringEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: WeightEditor;
        CalcOnId: Serenity.IntegerEditor;
        NetWeight: WeightEditor;
        Purity: Serenity.DecimalEditor;
        PureWeight: WeightEditor;
        Rate: Serenity.DecimalEditor;
        Amount: Serenity.DecimalEditor;
        DeliveryDate: Serenity.DateEditor;
    }

    export class IssueMaterialItemsForm extends Serenity.PrefixedContext {
        static formKey = 'Production.IssueMaterialItems';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IssueMaterialItemsForm.init)  {
                IssueMaterialItemsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = WeightEditor;
                var w3 = s.DecimalEditor;
                var w4 = s.DateEditor;

                Q.initFormType(IssueMaterialItemsForm, [
                    'TransDetailId', w0,
                    'TransItemId', w0,
                    'BagNo', w0,
                    'Line_No', w0,
                    'ProductId', w0,
                    'AttributeId', w0,
                    'Pieces', w1,
                    'Weight', w2,
                    'CalcOnId', w1,
                    'NetWeight', w2,
                    'Purity', w3,
                    'PureWeight', w2,
                    'Rate', w3,
                    'Amount', w3,
                    'DeliveryDate', w4
                ]);
            }
        }
    }
}
